/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_Analysis_CompleteInputs */

const en_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const de_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const fr_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const es_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const it_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const nl_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const pl_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const fi_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const da_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

const sv_keyword_optimizer_toast_analysis_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword analysis complete`)
};

/**
* | output |
* | --- |
* | "Keyword analysis complete" |
*
* @param {Keyword_Optimizer_Toast_Analysis_CompleteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_analysis_complete = /** @type {((inputs?: Keyword_Optimizer_Toast_Analysis_CompleteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Analysis_CompleteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_analysis_complete(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_analysis_complete(inputs)
	return en_keyword_optimizer_toast_analysis_complete(inputs)
});